module.exports = __webpack_public_path__ + "img/logo_jp.67811d6b.svg";